// export const acceptedImageFileTypes = 'image/jpg, image/png, image/jpeg  image/*'

export const acceptedImageFileTypes =
  'image/jpg, image/png, image/jpeg, image/svg, image/heic, image/png'
export const acceptedImageFilePdfTypes =
  'image/jpg, image/png, image/jpeg, image/svg, image/heic, image/png, application/pdf'
